// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxwtPH2HxsIaIDT_KB2c8w02IHFaa8TEw",
  authDomain: "mathboss.firebaseapp.com",
  projectId: "mathboss",
  storageBucket: "mathboss.appspot.com",
  messagingSenderId: "698330184700",
  appId: "1:698330184700:web:eab5395c11d376f2975079",
  measurementId: "G-DXJDZS39Q8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db }; 